"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _Search = _interopRequireDefault(require("@p24/icons/Search"));

var _Clear = _interopRequireDefault(require("@p24/icons/Clear"));

function _default(palette) {
  return {
    palette: palette,
    searchIcon: _Search["default"],
    clearIcon: _Clear["default"],
    searchIconWidth: palette.gutter * 3 + 'px',
    searchIconHeight: palette.gutter * 3 + 'px',
    clearIconHeight: palette.gutter * 3 + 'px',
    clearIconWidth: palette.gutter * 3 + 'px'
  };
}